import React, { useEffect, useState } from "react";
import { Link, useNavigate, NavLink } from "react-router-dom";
import $ from "jquery";
import { SITE_NAME } from "../config/AppConfig";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";
import { API_BASE_URL } from "../utils/app_url";
import facebookIcon from "../assets/img/facebook-icon.png";
import instagramIcon from "../assets/img/instagram-icon.png";
import snapchatIcon from "../assets/img/snapchat-icon.png";
import twitterxIcon from "../assets/img/twitterx-icon.png";
import youtubeIcon from "../assets/img/youtube-icon.png";
import appStoreIcon from "../assets/img/app-store-img.svg";
import googlePlayIcon from "../assets/img/google-play-img.svg";
import { useSiteData } from "../context/SiteDataContext";

const logo = require("./../assets/img/logo.png");

const Footer = () => {
  const { user } = useAuth();
  const { langJson } = useLanguage();
  const navigate = useNavigate();
  const { configs } = useSiteData();

  // Defensive: configs may be undefined or not an array
  const safeConfigs = Array.isArray(configs) ? configs : [];

  // Helper function for config lookup
  const getConfigValue = (name) => safeConfigs.find(item => item.name === name)?.value || "";

  return (
    <div>
      <div className="footerDiv">
        <div className="fullContainer">
          <div className="footTop">
            <div className="footSec footFirst">

              <div className="detailBtns appFooBtns">
                <Link
                  to="#url"
                  target="_blank"
                >
                  <img src={appStoreIcon} alt="App Store" />
                </Link>
                <Link
                  to="#url"
                  target="_blank"
                >
                  <img src={googlePlayIcon} alt="Google Play" />
                </Link>
              </div>
              <h1 className="footAppTxt">{langJson?.discover ?? 'Discover products on the go with the'} {SITE_NAME} app</h1>

            </div>
            <div className="footSec footMnu">
              <h2>{langJson?.getintouch}</h2>
              <ul>
                <li>
                  <Link to="/about-us">{langJson?.aboutus}</Link>
                </li>
                <li>
                  <Link to="/support">{langJson?.support}</Link>
                </li>
                
              </ul>
            </div>
            <div className="footSec">
              <h2>{langJson?.contactus}</h2>
              <ul>
                <li>
                  {langJson?.advisor} & {langJson?.support}: <br />{getConfigValue("support")}
                </li>
                <li>
                  {langJson?.email}:
                  {' '}<Link to={`mailto:${getConfigValue("email")}`} className="mailLink">
                    {getConfigValue("email")}
                  </Link>
                </li>
              </ul>
            </div>
            <div className="footSec touchIcons">
              <ul>
                {getConfigValue("facebook") && (
                  <li>
                    <Link to={getConfigValue("facebook")} target="_blank">
                      <img src={facebookIcon} alt="Facebook" />
                    </Link>
                  </li>
                )}
                {getConfigValue("twitter") && (
                  <li>
                    <Link to={getConfigValue("twitter")} target="_blank">
                      <img src={twitterxIcon} alt="Twitter" />
                    </Link>
                  </li>
                )}
                {getConfigValue("instagram") && (
                  <li>
                    <Link to={getConfigValue("instagram")} target="_blank">
                      <img src={instagramIcon} alt="Instagram" />
                    </Link>
                  </li>
                )}
                {getConfigValue("snapchat") && (
                  <li>
                    <Link to={getConfigValue("snapchat")} target="_blank">
                      <img src={snapchatIcon} alt="Snapchat" />
                    </Link>
                  </li>
                )}
                {getConfigValue("youtube") && (
                  <li>
                    <Link to={getConfigValue("youtube")} target="_blank">
                      <img src={youtubeIcon} alt="YouTube" />
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="footerBottomDiv">
        <div className="fullContainer">
          <div className="footBtmInner">
            <div className="footSec footBtm">
              <h3>
                ©{new Date().getFullYear()} {SITE_NAME}
              </h3>
              <ul>
                <li>
                  <Link to="/terms-of-use">{langJson?.termofuse}</Link>
                </li>
                <li>
                  <Link to="/privacy-policy">{langJson?.privacypolicy}</Link>
                </li>
                <li>
                  <Link to="/imprint">{langJson?.imprint}</Link>
                </li>
              </ul>
            </div>
            <div className="footSec footFirst">
              {user ? (null) : (
                <>
                  <div className="footRgtSec">

                    <div className="detailBtns">
                      <h1>{langJson?.best_selection ?? 'The best selection of brands for your store, all in one place'}</h1>
                      <Link to="/register" className="loginBtns">
                        {langJson?.signup_buy ?? 'Sign up to buy'}
                      </Link>
                      
                    </div>
                  </div>
                </>
              )}

            </div>


          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
